import LegalPage from "../components/site/LegalPage";
import fuente from "../content/legal/terminos-del-servicio.md";

// /terminos — Términos del Servicio (src/content/legal/terminos-del-servicio.md).
export default function TerminosPage() {
  return (
    <LegalPage
      fuente={fuente}
      ruta="/terminos"
      titulo="Términos del Servicio · SoyPacoIA"
      descripcion="Condiciones de uso de Lorena y los servicios de SoyPacoIA: prueba gratis, planes y pagos, cancelación, obligaciones y tratamiento de datos."
      otra={{ ruta: "/privacidad", texto: "Aviso de Privacidad" }}
    />
  );
}
